import Framework, { BaseService } from '@greenville/framework';
import _ from 'lodash';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';
import { normalizeTelemetryDetailResponse } from '../utils/telemetryUtils';

export default class TelemetryDetailService extends BaseService {
  constructor() {
    super(constants.GET_TELEMETRY_DETAIL, constants.TELEMETRY_DETAIL_STATUS);
  }

  async handleEvent(eventName, event) {
    const headers = {
      'x-berlin-tenant-id': event.payload.tenantId
    };
    const { traceId } = event.payload;
    let payload = _.omit(event.payload, ['traceId']);
    payload = _.omit(payload, ['tenantId']);
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').post(`${constants.TELEMETRY_SEARCH_ENDPOINT}/${traceId}`, payload, {
        headers: enhancedHeaders
      });
    }
    return this.getClient('aiadmin').post(`${constants.TELEMETRY_SEARCH_ENDPOINT}/${traceId}`, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    const body = data ?? response;
    const normalized = normalizeTelemetryDetailResponse(body);
    Framework.getStoreRegistry().getStore('telemetryDetail').setResponse(normalized);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        Framework.getStoreRegistry().getStore('notificationState').set({
          open: true,
          message: data.error.message,
          type: 'error'
        });
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      Framework.getStoreRegistry().getStore('notificationState').set({
        open: true,
        message: error.message,
        type: 'error'
      });
    }
    Framework.getStoreRegistry().getStore('telemetryDetail').resetStoreValues();
  }
}
